// Always use absolute URLs based on current origin to work with nginx reverse proxy
// This ensures all requests go through: nginx → API Gateway → microservices
const API_BASE_URL = `${window.location.origin}/api`;

class AuthService {


  async login(email, password) {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password })
    });

    if (!response.ok) {
      throw new Error('Invalid credentials');
    }

    const data = await response.json();

    // Store auth data
    localStorage.setItem('authToken', data.token);
    localStorage.setItem('userRole', data.roles?.includes('ROLE_SUPER_ADMIN') ? 'SUPER_ADMIN' : 'ADMIN');
    localStorage.setItem('userName', data.name || data.username);
    localStorage.setItem('userEmail', data.email);
    localStorage.setItem('isFirstTimeLogin', data.isFirstTimeLogin ? 'true' : 'false');

    return data;
  }

  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('isFirstTimeLogin');
  }

  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  }

  getUser() {
    const token = localStorage.getItem('authToken');
    const role = localStorage.getItem('userRole');
    const name = localStorage.getItem('userName');

    if (!token) return null;

    return {
      token,
      role,
      name
    };
  }



  async authenticatedFetch(url, options = {}) {
    const token = localStorage.getItem('authToken');

    if (!token) {
      throw new Error('No authentication token found');
    }

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers
    };

    return fetch(url, {
      ...options,
      headers
    });
  }

  async resetPasswordWithToken(token, newPassword) {
    const response = await fetch(`${API_BASE_URL}/super-admin/auth/reset-password-with-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token, newPassword })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to reset password');
    }

    return response.json();
  }
}

export default new AuthService();
